﻿export const ssnValidation = (ssn, country) => {
  if (country === 'sv' || country === 'se') {
    //YYYYMMDD-XXXX
    return (/^(19|20)[0-9]{6}-[0-9]{4}$/.test(ssn));
  } else if (country === 'fi') {
    //xxxxxx-zzzz (11 chars)
    //xxxxxxAzzzz (11 chars)
    //x = only digits
    //z = digits or letters
    return (/^[0-9]{6}[-A][0-9a-zA-Z]{4}$/.test(ssn));
  } else if (country === 'no' || country === 'nb') {
    //xxxxxxxxxx (11 chars)
    //x = only digits
    return (/^\d{11}$/.test(ssn));
  } else {
    return true;
  }
};

export const organisationValidation = (organisationNumber, country) => {
  if (organisationNumber.length === 0)
    return true;

  if (country === 'sv' || country === 'se') {
    //XXXXXX-YYYY
    return (/^[\d]{6}-[\d]{4}$/.test(organisationNumber));
  } else if (country === 'fi') {
    //XXXXXXX-Y
    return (/^[\d]{7}-[\d]{1}$/.test(organisationNumber));
  } else if (country === 'no' || country === 'nb') {
    //XXXXXXXXX
    return (/^[\d]{9}$/.test(organisationNumber));
  } else {
    return true;
  }
};

export const emailValidation = (email) => {
  if (/\S+@\S+\.\S+/.test(email))
    return true;
  return false;
};

export const zipcodeValidation = (zipcode, country) => {
  const onlyNumbers = zipcode.replace(/\D/g, '');
  const allButNumbers = zipcode.replace(/[0-9]/g, '');
  //We used to check number of digits in postal code, 4 for norway, 5 for sweden/finland.
  //But I think we used the country of the account, instead of the country selected in the address, for the validation.
  //And now that we added all the countries of the world we dont see the point in checking the formating only for the nordic ones.
  //So rather than fixing what country gets sent in I just change the validation to check that the field is not empty.
  //Country is no longer used in this validation
  /*if(country === 'no' || country === 'nb')
    return (onlyNumbers.length === 4 && allButNumbers.length === 0);*/

  return (onlyNumbers.length > 0 || allButNumbers.length > 0);
};

export const licensePlateValidation = (licensePlate, countryCode) => {
  const lp = licensePlate.replace(/\s+/g, '');
  if (countryCode && countryCode.toUpperCase() === 'S') {
    return lp.length > 1 && lp.length < 8 && (/^[A-Za-z0-9åÅäÄöÖ ]+$/.test(licensePlate));
  } else if (countryCode && countryCode.toUpperCase() === 'FIN') {
    return lp.length > 1 && lp.length < 8 && (/^[A-Za-z0-9åÅäÄöÖ-]+$/.test(licensePlate));
  } else if (countryCode && countryCode.toUpperCase() === 'N') {
    return lp.length > 1 && lp.length < 8 && (/^[A-Za-z0-9åÅäÄöÖüÜæÆøØ ]+$/.test(licensePlate));
  } else {
    return lp.length > 1 && (/^[A-Za-z0-9åÅäÄöÖüÜæÆøØ ]+$/.test(licensePlate));
  } 
  return false
};

export const phoneNumberValidation = (phonenumber) => {
  if (/^\+(?:[0-9] ?){6,14}[0-9]$/.test(phonenumber))
    return true;
  return false;
};

const formObjectValue = (item) => {
  if (!item.value)
    return item;

  if (!item.value.elementType || item.value.elementType === 'text' || item.value.elementType === 'phone' || item.value.elementType === 'ssn' || item.value.elementType === 'email' || item.value.elementType === 'password' || item.value.elementType === 'zipcode' || item.value.elementType === 'organisation' || item.value.elementType === 'time' || item.value.elementType === 'licenseplate')
    return item.value.text ?? item.value.Text ?? '';
  else if (item.value.elementType === 'date')
    return item.value.date ?? item.value.Date ?? null;
  else if (item.value.elementType === 'number')
    return item.value.number ?? item.value.Number ?? null;
  else if (item.value.elementType === 'select' && item.optionIdentifier)
    return item.value.item[item.optionIdentifier] ?? null;
  else if (item.value.elementType === 'select' && !item.optionIdentifier)
    return item.value.item.id ?? item.value.item.Id ?? null;
  else if (item.value.elementType === 'radio')
    return item.value.item.id ?? item.value.item.Id ?? null;
  else if (item.value.elementType === 'checkbox')
    return item.value.selected ?? item.value.Selected ?? false;
}

export const validateFormObject = (form, errorMessages, country = 'sv') => {
  let formValidationError = false;
  let cleanFormData = {};
  let flatCleanFormData = {};

  Object.keys(form).forEach(key => {
    let item = form[key];

    if (item.value.required && !item.value.elementType && item.value.text.length === 0 ||
      (item.value.required && item.value.elementType === 'text' && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'phone' && !item.value.skipValidation && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'licenseplate' && !item.value.skipValidation && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'date' && !item.value.date) ||
      (item.value.required && item.value.elementType === 'number' && !item.value.number && (item.value.text?.length ?? 0) === 0) ||
      (item.value.required && item.value.elementType === 'ssn' && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'organisation' && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'zipcode' && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'email' && item.value.text.length === 0) ||
      (item.value.required && item.value.elementType === 'checkbox' && !item.value.selected)) {
      //Required
      item.setValue({ ...item.value, error: errorMessages.required });
      if (!formValidationError) formValidationError = true;
    }
    else if (item.value.required && item.value.elementType === 'time' && item.value.text.length === 0) {
      //Required short
      item.setValue({ ...item.value, error: errorMessages.requiredShort ?? errorMessages.required });
      if (!formValidationError) formValidationError = true;
    }
    else if (!item.value.skipValidation && item.value.elementType && item.value.elementType === 'select' && item.value.required && !(item.value.item && item.value.item.Id) && (!(item.optionIdentifier ? item.value.item[item.optionIdentifier] : item.value.id) || (item.optionIdentifier ? item.value.item[item.optionIdentifier] : item.value.item.id) === '00000000-0000-0000-0000-000000000000')) {
      //Not selected
      item.setValue({ ...item.value, error: errorMessages.notSelected ?? 'Not Selected' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'phone' && item.value.required && !phoneNumberValidation(item.value.text) ||
      item.value.elementType && item.value.elementType === 'phone' && item.value.text.length > 0 && !phoneNumberValidation(item.value.text)) {
      //Phone number
      item.setValue({ ...item.value, error: errorMessages.phoneMalformed ?? 'Phone Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'licenseplate' && item.value.required && !licensePlateValidation(item.value.text, item.value.countryCode) ||
      item.value.elementType && item.value.elementType === 'licenseplate' && item.value.text && item.value.text.length > 0 && !licensePlateValidation(item.value.text, item.value.countryCode)) {
      //License plate
      if (item.value.multiple) item.value = { ...item.value, error: errorMessages.lpMalformed ?? 'License Plate Malformed' };
      else item.setValue({ ...item.value, error: errorMessages.lpMalformed ?? 'License Plate Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'ssn' && item.value.required && !ssnValidation(item.value.text, country) ||
      item.value.elementType && item.value.elementType === 'ssn' && item.value.text.length > 0 && !ssnValidation(item.value.text, country)) {
      //Social security number
      item.setValue({ ...item.value, error: errorMessages.ssnMalformed ?? 'SSN Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'organisation' && item.value.required && !organisationValidation(item.value.text, country) ||
      item.value.elementType && item.value.elementType === 'organisation' && item.value.text.length > 0 && !organisationValidation(item.value.text, country)) {
      //Organisation number
      item.setValue({ ...item.value, error: errorMessages.organisationNumberMalformed ?? 'Organisation Number Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'zipcode' && item.value.required && !zipcodeValidation(item.value.text, country) ||
      item.value.elementType && item.value.elementType === 'zipcode' && item.value.text.length > 0 && !zipcodeValidation(item.value.text, country)) {
      //Zipcode
      item.setValue({ ...item.value, error: errorMessages.zipcodeMalformed ?? 'Zipcode Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    else if (
      !item.value.skipValidation &&
      item.value.elementType && item.value.elementType === 'email' && item.value.required && !emailValidation(item.value.text) ||
      item.value.elementType && item.value.elementType === 'email' && item.value.text.length > 0 && !emailValidation(item.value.text)) {
      //Email address
      item.setValue({ ...item.value, error: errorMessages.emailMalformed ?? 'Email Malformed' });
      if (!formValidationError) formValidationError = true;
    }
    // Ńo errors
    else if (item.value.elementType === 'licenseplate') {
      if (item.value.multiple) item.value = { ...item.value, error: null };
      else item.setValue({ ...item.value, error: null })
    }
    else
    {
      item.setValue({ ...item.value, error: null });
    }

    cleanFormData[key] = item.value;
    flatCleanFormData[key] = formObjectValue(item);
  });

  return [formValidationError, cleanFormData, flatCleanFormData];
}

const formObjectValueAlt = (item) => {
  if (!item)
    return null;

  if(!item.elementType || item.elementType === 'text' || item.elementType === 'ssn' || item.elementType === 'email' || item.elementType === 'password' || item.elementType === 'zipcode')
    return item.text ?? item.Text ?? '';
  else if (item.elementType === 'date')
    return item.date ?? item.Date ?? null;
  else if (item.elementType === 'number')
    return item.number ?? item.Number ?? item.text ?? null;
  else if (item.elementType === 'select')
    return item.item.id ?? item.item.Id ?? null;
  else if (item.elementType === 'radio')
    return item.item.id ?? item.item.Id ?? null;
  else if (item.elementType === 'checkbox')
    return item.selected ?? item.Selected ?? false;
}

export const validateFormObjectAlt = (form, errorMessages, language = 'sv') => {
  let formValidationError = false;
  let cleanFormData = {};
  let flatCleanFormData = {};
  let updatedForm = form;

  Object.keys(form).forEach(key => {
    let item = form[key];

    if (!item)
      return;

    if(item.required && !item.elementType && item.text.length === 0 ||
      (item.required && item.elementType === 'text' && item.text.length === 0) ||
      (item.required && item.elementType === 'date' && !item.date) ||
      (item.required && item.elementType === 'number' && !item.number) ||
      (item.required && item.elementType === 'ssn' && item.text.length === 0) ||
      (item.required && item.elementType === 'zipcode' && item.text.length === 0) ||
      (item.required && item.elementType === 'email' && item.text.length === 0) ||
      (item.required && item.elementType === 'checkbox' && !item.selected))
    {
      //Required
      updatedForm[key] = { ...item, error: errorMessages.required };
      if(!formValidationError) formValidationError = true;
    }
    else if (!item.skipValidation && item.elementType && item.elementType === 'select' && item.required && item.id === 0)
    {
      //Not selected
      updatedForm[key] = { ...item, error: errorMessages.notSelected };
      if(!formValidationError) formValidationError = true;
    }
    else if (
      !item.skipValidation &&
      item.elementType && item.elementType === 'ssn' && item.required && !ssnValidation(item.text, language) ||
      item.elementType && item.elementType === 'ssn' && item.text.length > 0 && !ssnValidation(item.text, language))
    {
      //Social security number
      updatedForm[key] = { ...item, error: errorMessages.ssnMalformed };
      if(!formValidationError) formValidationError = true;
    }
    else if (
      !item.skipValidation &&
      item.elementType && item.elementType === 'zipcode' && item.required && !zipcodeValidation(item.text, language) ||
      item.elementType && item.elementType === 'zipcode' && item.text.length > 0 && !zipcodeValidation(item.text, language))
    {
      //Zipcode
      updatedForm[key] = { ...item, error: errorMessages.zipcodeMalformed };
      if(!formValidationError) formValidationError = true;
    }
    else if (
      !item.skipValidation &&
      item.elementType && item.elementType === 'email' && item.required && !emailValidation(item.text) ||
      item.elementType && item.elementType === 'email' && item.text.length > 0 && !emailValidation(item.text))
    {
      //Email address
      updatedForm[key] = { ...item, error: errorMessages.emailMalformed };
      if(!formValidationError) formValidationError = true;
    }
    else
    {
      // No errors
      updatedForm[key] = { ...item, error: null };
    }

    cleanFormData[key] = item;
    flatCleanFormData[key] = formObjectValueAlt(item);
  });

  return [updatedForm, formValidationError, cleanFormData, flatCleanFormData];
}
